import {
  Outlet,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import SideBar from "./components/sideBar";
import { useEffect, useState } from "react";
import PlusIcon from "@/assets/icons/Plus.svg";
import Modal from "../ui/Modal";
import CreateProjectModal from "../ui/CreateProjectModal";
import { MobileBottomNav } from "@/constant";
import SidebarLink from "./components/SidebarLink";
import MobileSideBar from "./components/mobileSideBar";
import Header from "./components/header";
import { useAppDispatch, useAppSelector } from "@/redux/hooks/hooks";
import { useGetMeQuery } from "@/redux/feature/user/userApi";
import { isCurrentRoute } from "@/utils/isCurrentRoute";
import { setExpanded } from "@/redux/feature/sidebar/sidebarSlice";
import { ToastProvider } from "../ui/ToastContext";
import { UserDetails } from "@/types/types";
import { setUserAvailableRevisions } from "@/redux/feature/global/globalSlice";
import { initiateSocket } from "@/services/websocket/socket";
import { logOut } from "@/redux/feature/auth/authSlice";
import { CustomButton } from "../ui/Buttons";
import XRounded from "@/assets/icons/XRounded.svg";
import ProjectRequestModal from "../ProjectRequestModal";
import { initializeHelpScoutBeacon } from "@/services/helpScoutBeacon";

const RootLayout = () => {
  const isExpanded = useAppSelector((state) => state.sidebar.isExpanded);
  const dispatch = useAppDispatch();
  const [ShowCreateProjectModal, setShowCreateProjectModal] = useState(false);
  const location = useLocation();
  const pathname = location.pathname;
  const { id: orderId } = useParams();

  const currentRoute = pathname
    .split("/")
    .slice(0, 4)
    .join("/")
    .split(`${orderId}`)
    .join("")
    .replace(/\/$/, "");

  // Show header only on dashboard and orders pages
  // Define the valid routes for each condition
  const orderButtonRoutes = [
    "/",
    "/dashboard",
    "/orders",
    "/pricing",
    "/billings",
  ];
  const desktopHeaderRoutes = [
    "/",
    "/dashboard",
    "/pricing",
    "/projects",
    "/jobs",
    "/messages",
  ];
  const mobileHeaderRoutes = [
    "/",
    "/dashboard",
    "/pricing",
    "/billings",
    "/billing-settings",
    "/setting",
    "/projects",
    "/notification",
    "/jobs",
    "/wallet",
    "/messages",
  ];

  const hideMobileBottomNavRoutes = [
    "/orders/create-order/plan-selection",
    "/orders/create-order/actor-and-video-details",
    "/orders/create-order/order-summary",
    "/orders/order-management",
    "/templates/create-order/video-brief",
    "/templates/create-order/creator-selection",
    "/templates/create-order/video-editing",
    "/templates/create-order/order-summary",
    "/messages",
  ];
  const hideSideBarRoutes = [
    "/orders/create-order/plan-selection",
    "/orders/create-order/actor-and-video-details",
    "/orders/create-order/order-summary",
    "/orders/order-management",
    "/templates/create-order/video-brief",
    "/templates/create-order/creator-selection",
    "/templates/create-order/video-editing",
    "/templates/create-order/order-summary",
    // "/messages",
  ];

  // Use the utility function to check the routes
  const showOrderButton = isCurrentRoute(currentRoute, orderButtonRoutes);
  const showDesktopHeader = isCurrentRoute(currentRoute, desktopHeaderRoutes);
  const showMobileHeader = isCurrentRoute(currentRoute, mobileHeaderRoutes);
  const showMobileBottomNav = isCurrentRoute(
    currentRoute,
    hideMobileBottomNavRoutes,
  );
  // console.log(showMobileBottomNav);
  const hideSidebar = isCurrentRoute(currentRoute, hideSideBarRoutes);
  // User data
  const { user } = useAppSelector((state) => state.auth);
  const { data, isLoading, isFetching } = useGetMeQuery(user?.email);
  useEffect(() => {
    if (!isLoading && !isFetching) {
      if (data && !data.data) {
        dispatch(logOut());
      }
    }
  }, [data, isLoading, isFetching, dispatch]);

  useEffect(() => {
    initializeHelpScoutBeacon();
  }, []);

  // if()
  const [searchParams, setSearchParams] = useSearchParams();
  const projectIdFromUrl = searchParams.get("project_id");
  const [showProjectRequestModal, setShowProjectRequestModal] = useState(false);
  const [projectRequestId, setProjectRequestId] = useState<string | null>(null);
  useEffect(() => {
    if (!projectIdFromUrl) return;

    setProjectRequestId(projectIdFromUrl);
    setShowProjectRequestModal(true);
  }, [projectIdFromUrl]);

  const closeProjectRequestModal = () => {
    setShowProjectRequestModal(false);

    // ✅ optional: remove query param so it won't reopen on refresh
    const next = new URLSearchParams(searchParams);
    next.delete("project_id");
    setSearchParams(next, { replace: true });
  };
  // const credits = data?.data?.credits;

  // const userData: UserDetails | undefined = data?.data;
  // const userEmail = user?.email as string;

  // useEffect(() => {
  //   if (userData) {
  //     dispatch(
  //       setUserAvailableRevisions(
  //         userData?.purchasedPlan?.planId?.availableRevisions
  //       )
  //     );
  //   }
  // }, [userData, userEmail, token]);

  // useEffect(() => {
  //   if (Notification.permission === "default") {
  //     Notification.requestPermission().then(permission => {
  //       if (permission === "granted") {
  //         console.log("Notification permission granted.");
  //       } else {
  //         console.log("Notification permission denied.");
  //       }
  //     });
  //   }
  // }, []);

  // const totalCredits = useCalcula?teTotalCredits()
  // console.log(totalCredits);

  // console.log(currentRoute);

  return (
    <div className="flex relative">
      {!hideSidebar && (
        <div
          onMouseEnter={() => dispatch(setExpanded(true))}
          onMouseLeave={() => dispatch(setExpanded(false))}
          className={`${
            isExpanded ? "w-[206px]" : "w-[76px]"
          } border-r border-[#F0F0F3] transform md:block hidden duration-300 ease-in-out transition-all `}
        >
          <SideBar isExpanded={isExpanded} setExpanded={setExpanded} />
        </div>
      )}
      <div className="md:hidden block">
        <MobileSideBar />
      </div>
      {/* Mobile bottom nav */}
      {!showMobileBottomNav && (
        <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-[#F0F0F3] px-4 z-40 py-2 overflow-x-auto overflow-y-hidden">
          <ul className="flex items-center justify-between min-w-max">
            {MobileBottomNav.map((item, i) => (
              <SidebarLink key={i} pathname={pathname} data={item} />
            ))}
          </ul>
        </div>
      )}

      <div
        className={`w-full min-h-[100dvh] pl-0 relative md:h-screen md:overflow-y-auto md:pb-0 ${
          !showMobileBottomNav ? "pb-24" : ""
        }`}
      >
        <div className="hidden md:block">
          {showDesktopHeader && !showMobileBottomNav && <Header />}
        </div>
        <div className="md:hidden">
          {showMobileHeader && !showMobileBottomNav && <Header />}
        </div>

        <Outlet />

        <Modal
          isOpen={ShowCreateProjectModal}
          setOpen={setShowCreateProjectModal}
        >
          <CreateProjectModal />
        </Modal>
        <ProjectRequestModal
          isOpen={showProjectRequestModal}
          projectId={projectRequestId}
          onClose={closeProjectRequestModal}
        />
      </div>
    </div>
  );
};

export default RootLayout;
